import { AccredibleCookiesBannerComponentModule } from '@accredible-frontend-v2/components/cookies-banner';
import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Event, NavigationEnd, Router, RouterEvent, RouterModule } from '@angular/router';
import { LerAuthenticationApiService } from '@ler/domain';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../header/header.component';

@Component({
  standalone: true,
  selector: 'ler-shell',
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  imports: [RouterModule, AccredibleCookiesBannerComponentModule, HeaderComponent],
})
export class ShellComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _authenticationApi = inject(LerAuthenticationApiService);
  private readonly _userApi = inject(AccredibleUserApiService);
  private readonly _destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this._checkSessionOnNavigationEnd();
    this._reloadOnLogout();
  }

  private _checkSessionOnNavigationEnd(): void {
    this._router.events
      .pipe(
        filter((event: Event | RouterEvent) => event instanceof NavigationEnd),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(() => {
        this._authenticationApi.checkLocalSession();
      });
  }

  private _reloadOnLogout(): void {
    this._userApi.onLogout$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((loggedOut) => {
      // On logout, refresh the page
      if (loggedOut) {
        window.location.reload();
      }
    });
  }
}
